export const MAIN_PAGE_ROUTE:string = "/main"
export const COMPARE_PAGE_ROUTE:string = "/compare"
export const IDENTICAL_PAGE_ROUTE:string = "/identical"
export const ASCII_PAGE_ROUTE:string = "/ascii"